import Vue from "vue";
import Router from "vue-router";
import Home from "../views/Home/Home.vue";
import store from "../store/store";
import { authRoutesRegex } from "../util/func";
import DisplayExportRoutes from "./exports/display";
import PartnersRoutes from "./partners";
import ContactsRoutes from "./contacts";
import ProjectsRoutes from "./projects";
import AuthRoutes from "./auth";
import Outils from "../views/Outils/Outils.vue";

Vue.use(Router);

const r = new Router({
  mode: "history",
  routes: [
    {
      path: "/",
      redirect: "/home"
    },
    {
      path: "/home",
      name: "home",
      component: Home
    },
    {
      path: "/outils",
      name: "outils",
      component: Outils
    },
    {
      path: "/cherchables",
      name: "Cherchables",
      component: () => import("../views/Cherchables")
    },
    {
      path: "/export",
      name: "Export",
      component: () => import("../views/Export/Index")
    },
    {
      path: "/agence",
      name: "Agence",
      component: () => import("../views/Agence/Index")
    },
    {
      path: "/website/axes",
      name: "Axes de travail",
      component: () => import("../views/Website/Axes")
    },
    {
      path: "/website/sequence",
      name: "Sequence d'accueil",
      component: () => import("../views/Website/Sequence_accueil")
    },
    {
      path: "/website/home_v2",
      name: "V2 Home",
      component: () => import("../views/Website/Home_v2")
    },
    {
      path: "/website/projects_selection",
      name: "Projets sélectionnés",
      component: () => import("../views/Website/Projects_selection")
    },
    {
      path: "/website/projects",
      name: "Affichage Projets",
      component: () => import("../views/Website/Projects")
    },
    {
      path: "/website/informations",
      name: "Page informations",
      component: () => import("../views/Website/About")
    },
    {
      path: "/website/tech",
      name: "Options techniques",
      component: () => import("../views/Website/Tech")
    },
    {
      path: "/website/menu",
      name: "Menus et intitulés",
      component: () => import("../views/Website/Menus")
    },
    ...AuthRoutes,
    ...ProjectsRoutes,
    ...ContactsRoutes,
    ...PartnersRoutes,
    ...DisplayExportRoutes
  ]
});

/**
 * Handles route guards when data is potentially not saved.
 * @param from
 * @param to
 * @returns {boolean}
 */
export const routeNeedsConfirm = (from, to) => {
  if (from.path === to.path) return false;
  if (/edit/.test(from.path)) {
    return !(from && from.query && from.query.s);
  }
  return false;
};

r.beforeEach((to, from, next) => {
  if (routeNeedsConfirm(from, to)) {
    const p = confirm(
      `Attention ! Vous n'avez pas forcément sauvegardé.
        Voulez-vous vraiment quitter la page ?`
    );
    if (p) {
      return next();
    } else {
      return next(false);
    }
  }
  if (!store.getters.isAuthenticated && !authRoutesRegex.test(to.path))
    return next("/auth/login");
  return next();
});

export default r;
